import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon63: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M12.5 0C12.7761 0 13 0.224 13 0.5V4H15.5C15.7455 4 15.9496 4.177 15.9919 4.41L16 4.5V19.5C16 19.776 15.7761 20 15.5 20H3.5C3.2239 20 3 19.776 3 19.5V16H0.5C0.2545 16 0.0503986 15.823 0.0080986 15.59L0 15.5V0.5C0 0.224 0.2239 0 0.5 0H12.5ZM15 5H4V19H15V5ZM12 1H1V15H3V4.5C3 4.255 3.1769 4.05 3.4101 4.008L3.5 4H12V1ZM12.5 13C12.7761 13 13 13.224 13 13.5C13 13.776 12.7761 14 12.5 14H6.5C6.2239 14 6 13.776 6 13.5C6 13.224 6.2239 13 6.5 13H12.5ZM12.5 10C12.7761 10 13 10.224 13 10.5C13 10.776 12.7761 11 12.5 11H6.5C6.2239 11 6 10.776 6 10.5C6 10.224 6.2239 10 6.5 10H12.5ZM12.5 7C12.7761 7 13 7.224 13 7.5C13 7.776 12.7761 8 12.5 8H6.5C6.2239 8 6 7.776 6 7.5C6 7.224 6.2239 7 6.5 7H12.5Z"
        fill="#404040"
      />
    </Icon>
  )
}
